<div
  id="chartPortfolio"
  style="width: 100%"
  [style]="{ height: height }"
  [ngClass]="{ 'h-[130px] lg:h-[300px]': mobileNewLayout }"
></div>
